import React, { useState } from 'react';
import { ToastContext } from 'contexts';
import { Toast } from 'bonfire-kindling';
import { STD_ERROR, STD_SUCCESS } from 'constants/toastMessages';

const ToastProvider = ({ children, ...rest }) => {
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('error');
  const [toastDuration, setToastDuration] = useState(5000);
  const [toastIsOpen, setToastIsOpen] = useState(false);

  const triggerToast = React.useCallback(({ message = '', variant = 'error', duration = 5000 }) => {
    const fallback = variant === 'success' ? STD_SUCCESS : STD_ERROR;
    setToastMessage(message || fallback);
    setToastVariant(variant);
    setToastDuration(duration);
    setToastIsOpen(true);

    // Return cleanup function useful within useEffect hooks
    return () => setToastIsOpen(false);
  }, []);

  return (
    <ToastContext.Provider value={{ triggerToast }} {...rest}>
      {children}
      <Toast
        open={toastIsOpen}
        autoHideDuration={toastDuration}
        onClose={() => setToastIsOpen(false)}
        variant={toastVariant}
      >
        {toastMessage}
      </Toast>
    </ToastContext.Provider>
  );
};

export default ToastProvider;
